"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Content = _interopRequireDefault(require("./Content"));

var _Header = _interopRequireDefault(require("./Header"));

var _Subheader = _interopRequireDefault(require("./Subheader"));

var _Divider = _interopRequireDefault(require("./Divider"));

var _CardSt = require("./Card.st.css");

var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-style-react/dist/cjs/Card/Card.js",
    _this = void 0;

var Card = function Card(_ref) {
  var stretchVertically = _ref.stretchVertically,
      showShadow = _ref.showShadow,
      hideOverflow = _ref.hideOverflow,
      className = _ref.className,
      children = _ref.children,
      controls = _ref.controls,
      dataHook = _ref.dataHook;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _CardSt.st)(_CardSt.classes.card, {
      stretchVertically: stretchVertically,
      hideOverflow: hideOverflow,
      showShadow: showShadow
    }, className),
    "data-hook": dataHook,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 3
    }
  }, controls && /*#__PURE__*/_react["default"].createElement("div", {
    className: _CardSt.classes.controls,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 18
    }
  }, controls), children);
};

Card.displayName = 'Card';
Card.propTypes = {
  /** Contains elements inside the card `<Card.Header/>`, `<Card.Subeader/>`, `<Card.Content/>` or `<Card.Divider/>` */
  children: _propTypes["default"].node,

  /** Applies a CSS class to the component’s root element */
  className: _propTypes["default"].string,

  /** Contains elements that control the component (usually a <CloseButton/>) */
  controls: _propTypes["default"].node,

  /** Makes a card stretch vertically to max height in a layout or container */
  stretchVertically: _propTypes["default"].bool,

  /** Applies a drop shadow effect */
  showShadow: _propTypes["default"].bool,

  /** Hides a portion of card content that overflows its dimensions */
  hideOverflow: _propTypes["default"].bool,

  /** Applies a data-hook HTML attribute to be used in the tests */
  dataHook: _propTypes["default"].string
};
Card.defaultProps = {
  stretchVertically: false,
  showShadow: false
};
Card.Content = _Content["default"];
Card.Header = _Header["default"];
Card.Divider = _Divider["default"];
Card.Subheader = _Subheader["default"];
var _default = Card;
exports["default"] = _default;
//# sourceMappingURL=Card.js.map